<template>
  <!-- <div class="index" v-if="projectList && projectList.length>0">
    <div v-for="project in projectList" :key="project.id" class="project-card">
      <div class="project-name">
        <project-status :status="project.status"></project-status>
        <label class="name">
          {{project.name}}
        </label>
      </div>
      <a-row class="info-panel">
        <a-col :span="6">
          <div class="contact">
            <label>{{project.contactName}}</label><label>（项目负责人）</label>
          </div>
          <template  v-for="(info,index) in project.infoList" >
            <div class="role-info" v-if="roleData[info.role]" :key="index">
              <label>{{roleData[info.role]}}</label><label>（我的角色）</label>
            </div>
          </template>
        </a-col>
        <template  v-for="(info,index) in project.infoList" >
          <a-col :span="18" v-if="info.role==='PROJECT_GATHER'" :key="index">
            <a-row >
              <template v-for="(item,ii) in handleInfo(info)">
                <a-col :class="'info info'+(ii+1)" :span="5" @click="infoClick(item,project.id,project.name)">
                  <div >
                    <div class="value">{{item.value}}</div>
                    <div class="name">{{item.name}}</div>
                  </div>
                </a-col>
              </template>
              <a-col :span="3" class="btn-panel">
                <div><a-button size="small" type="primary" class="btn" @click="patientListGo(project.id,project.name)">受试者列表</a-button></div>
                <div><a-button size="small" class="btn" @click="periodItemGo(project.id,undefined,project.name)">执行随访</a-button></div>
              </a-col>
            </a-row>
          </a-col>
        </template>
      </a-row>
    </div>
  </div>
  <a-empty v-else /> -->

  <div class="box">

    <header>
      <div class="left">
        <a-dropdown>
          <img :src="require(`@/assets/${this.userInfo().sex === 0 ? 'lady' : 'gentlemen'}.jpg`)" width="60" height="60" alt="" @click="e => e.preventDefault()">
          <a-menu slot="overlay">
            <a-menu-item @click="reloadWindow">
              <a-icon type="sync" spin/>
              <span>系统更新</span>
            </a-menu-item>
            <a-menu-item @click="updatePassword">
              <a-icon type="setting"/>
              <span>密码修改</span>
            </a-menu-item>
            <a-menu-item @click="updateCurrentCenterId" v-has="'project:change:centerId'">
              <a-icon type="cluster"/>
              <span>切换中心</span>
            </a-menu-item>
            <a-menu-item @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>              
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <div class="top">
          <div class="name">
            <strong>{{ this.userInfo().realname }}</strong>
            <!-- <span>教授</span> -->
          </div>
          <!-- <div class="position">骨科 | 主治医生</div> -->
        </div>
      </div>
      <div class="right" v-if="menus.length === 2">
        <a-button @click="handleCreate">
          <a-icon type="plus"/>
          配置方案
        </a-button>
      </div>
    </header>
    <main>
      <div class="left">
        <!-- <div class="top">
          <icon-back class="back" color="rgba(33, 34, 39, 1)" @back="back"></icon-back>
          <a-switch
            v-model="switchValue"
            :checked-children="checkedChildren"
            :un-checked-children="unCheckedChildren">
          </a-switch>
          <strong>队列研究列表</strong>
        </div> -->
        <div class="list" v-if="projectList.length !== 0">
          <div class="main" :class="[cur === index ? 'main1' : 'main2']" v-for="(project, index) in projectList"
            :key="project.id" @click="handleClick(index)">
            <div class="title">
              <img :src="require(`@/assets/item-icon${cur === index ? '' : '01'}.png`)" alt="">
              <span>{{ project.name }}</span>
            </div>
            <div class="item item1">
              <dl>
                <dt>研究科室</dt>
                <dd v-if="JSON.parse(project.deptJson?project.deptJson:'[]').length !==0">
                  <div class="dd-list" v-for="list in JSON.parse(project.deptJson?project.deptJson:'[]')" :key="list.id">{{ list.name }}</div>
                </dd>
                <dd v-else>
                  -
                </dd>
              </dl>
              <dl>
                <dt>研究病种</dt>
                <dd v-if="JSON.parse(project.diseaseJson?project.diseaseJson:'[]').length !==0">
                  <div class="dd-list" v-for="list in JSON.parse(project.diseaseJson?project.diseaseJson:'[]')" :key="list.id">{{ list.name }}</div>
                </dd>
                <dd v-else>
                  -
                </dd>
              </dl>
            </div>
            <div class="item item2">
              <dl>
                <dt>负责人</dt>
                <dd>{{ project.projectCreateUserName||'-' }}</dd>
              </dl>
              <dl>
                <dt>计划入组人数</dt>
                <dd>{{ project.sampleCount }}</dd>
              </dl>
            </div>
            <div class="item item2">
              <dl>
                <dt>建设周期</dt>
                <dd>{{ project.startDate }} ~ {{ project.planEndDate }}</dd>
              </dl>
            </div>
          </div>
        </div>
        <a-empty class="empty" v-else />
      </div>
      <div class="line"></div>
      <div class="right">
        <!-- <div class="top">中国种植体周健康大数据库种植人群队列</div> -->
        <div class="scroll-content">
          <div class="right-content">
            <div class="item1">
              <div class="title">
                <img :src="require(`@/assets/item-icon01.png`)" alt="">
                <strong>{{ projectItem.name }}</strong>
                <project-status :status="projectItem.status"></project-status>
              </div>
              <div class="user" v-if="menus.length === 2 && !isPI && projectItem.memberList && projectItem.memberList.length !==0">
                <div class="num">
                  <span>项目成员数量</span>
                  <strong >{{ projectItem.memberList.length}}</strong>
                </div>
                <div class="user-list">
                  <div v-for="(item,key) in projectItem.memberList" :key="key">
                    <div class="pm" v-for="(m,n) in item" :key="n">
                      <img width="40" :src="require(`@/assets/avatar.png`)" alt="">
                      <div class="job">
                        <strong>{{ n }}</strong>
                        <a-tag>{{ m[0]||'未知角色' }}</a-tag>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="item2" v-if="menus.length === 2 && !isPI">
              <div class="title" v-if="curProgress.length !== 0">项目当前进度</div>
              <div class="chart-list">
                <div class="chart" v-for="(item,index) in curProgress" :key="index">
                  <div :id="'chart' + index" style="width: 150px; height: 150px;"></div>
                  <div class="discribe">
                    <strong>{{ item.title }}</strong>
                    <span>{{ item.text }}</span>
                  </div>
                </div>
              </div>
            </div>             -->
            <div class="report-container" v-if="isPI">
              <div class="module">                
                <div class="module-content">
                  <div class="column">
                    <div class="row">
                      <div class="data-card">
                        <div class="data-label">  
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g id="vuesax/bold/frame">
                              <g id="frame">
                              <path id="Vector" d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z" fill="#1677FF"/>
                              <path id="Vector_2" d="M17.08 14.15C14.29 12.29 9.73996 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z" fill="#1677FF"/>
                              </g>
                              </g>
                              </svg>昨日入组(人)
                          </div>
                        <div class="data-value" >{{viewInfoData1["yesterday_pass"]}}</div>
                      </div>
                      <div class="data-card">
                        <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="vuesax/bold/profile-2user">
          <g id="profile-2user">
          <path id="Vector" d="M9.6665 2C7.0465 2 4.9165 4.13 4.9165 6.75C4.9165 9.32 6.9265 11.4 9.5465 11.49C9.6265 11.48 9.7065 11.48 9.7665 11.49C9.7865 11.49 9.7965 11.49 9.8165 11.49C9.8265 11.49 9.8265 11.49 9.8365 11.49C12.3965 11.4 14.4065 9.32 14.4165 6.75C14.4165 4.13 12.2865 2 9.6665 2Z" fill="#1677FF"/>
          <path id="Vector_2" d="M14.7465 14.15C11.9565 12.29 7.40646 12.29 4.59646 14.15C3.32646 15 2.62646 16.15 2.62646 17.38C2.62646 18.61 3.32646 19.75 4.58646 20.59C5.98646 21.53 7.82646 22 9.66646 22C11.5065 22 13.3465 21.53 14.7465 20.59C16.0065 19.74 16.7065 18.6 16.7065 17.36C16.6965 16.13 16.0065 14.99 14.7465 14.15Z" fill="#1677FF"/>
          <path id="Vector_3" d="M20.6564 7.33998C20.8164 9.27998 19.4364 10.98 17.5264 11.21C17.5164 11.21 17.5164 11.21 17.5064 11.21H17.4764C17.4164 11.21 17.3564 11.21 17.3064 11.23C16.3364 11.28 15.4464 10.97 14.7764 10.4C15.8064 9.47998 16.3964 8.09998 16.2764 6.59998C16.2064 5.78998 15.9264 5.04998 15.5064 4.41998C15.8864 4.22998 16.3264 4.10998 16.7764 4.06998C18.7364 3.89998 20.4864 5.35998 20.6564 7.33998Z" fill="#1677FF"/>
          <path id="Vector_4" d="M22.6567 16.59C22.5767 17.56 21.9567 18.4 20.9167 18.97C19.9167 19.52 18.6567 19.78 17.4067 19.75C18.1267 19.1 18.5467 18.29 18.6267 17.43C18.7267 16.19 18.1367 15 16.9567 14.05C16.2867 13.52 15.5067 13.1 14.6567 12.79C16.8667 12.15 19.6467 12.58 21.3567 13.96C22.2767 14.7 22.7467 15.63 22.6567 16.59Z" fill="#1677FF"/>
          </g>
          </g>
          </svg>当月入组(人)</div>
                        <div class="data-value">{{viewInfoData1["month_pass"]}}</div>
                      </div>
                      <div class="data-card" style="margin-right: 15px;">
                        <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="vuesax/bold/people">
          <g id="people">
          <path id="Vector" d="M17.8635 7.77C17.7935 7.76 17.7235 7.76 17.6535 7.77C16.1035 7.72 14.8735 6.45 14.8735 4.89C14.8735 3.3 16.1635 2 17.7635 2C19.3535 2 20.6535 3.29 20.6535 4.89C20.6435 6.45 19.4135 7.72 17.8635 7.77Z" fill="#1677FF"/>
          <path id="Vector_2" d="M21.1236 14.7C20.0036 15.45 18.4336 15.73 16.9836 15.54C17.3636 14.72 17.5636 13.81 17.5736 12.85C17.5736 11.85 17.3536 10.9 16.9336 10.07C18.4136 9.86998 19.9836 10.15 21.1136 10.9C22.6936 11.94 22.6936 13.65 21.1236 14.7Z" fill="#1677FF"/>
          <path id="Vector_3" d="M6.77365 7.77C6.84365 7.76 6.91365 7.76 6.98365 7.77C8.53365 7.72 9.76365 6.45 9.76365 4.89C9.76365 3.29 8.47365 2 6.87365 2C5.28365 2 3.99365 3.29 3.99365 4.89C3.99365 6.45 5.22365 7.72 6.77365 7.77Z" fill="#1677FF"/>
          <path id="Vector_4" d="M6.88361 12.85C6.88361 13.82 7.09361 14.74 7.47361 15.57C6.06361 15.72 4.59361 15.42 3.51361 14.71C1.93361 13.66 1.93361 11.95 3.51361 10.9C4.58361 10.18 6.09361 9.88998 7.51361 10.05C7.10361 10.89 6.88361 11.84 6.88361 12.85Z" fill="#1677FF"/>
          <path id="Vector_5" d="M12.4533 15.87C12.3733 15.86 12.2833 15.86 12.1933 15.87C10.3533 15.81 8.8833 14.3 8.8833 12.44C8.8933 10.54 10.4233 9 12.3333 9C14.2333 9 15.7733 10.54 15.7733 12.44C15.7633 14.3 14.3033 15.81 12.4533 15.87Z" fill="#1677FF"/>
          <path id="Vector_6" d="M9.2033 17.94C7.6933 18.95 7.6933 20.61 9.2033 21.61C10.9233 22.76 13.7433 22.76 15.4633 21.61C16.9733 20.6 16.9733 18.94 15.4633 17.94C13.7533 16.79 10.9333 16.79 9.2033 17.94Z" fill="#1677FF"/>
          </g>
          </g>
          </svg>总共入组(人)</div>
                        <div class="data-value">{{viewInfoData1["year_pass"]}}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div ref="passGroupCenterChart" class="chart-1"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="module">
                  <div class="module-content">
                  <div class="column">
                    <div ref="monthEnrollChart" class="chart-2"></div>          
                    <div class="timeButtons">                      
                      <button 
                        v-for="type in buttonTypes"
                        :key="type.value"
                        :class="{ active: currentType === type.value }"
                        @click="handleTypeChange(type.value)"
                      >
                        {{ type.label }}
                      </button>
                    </div>
                  </div>
                  </div>
              </div>
              <div class="module">
                  <div class="module-content">
                  <div class="column">
                    <div ref="periodRateChart" class="chart-3" style="margin-left: 0"></div>
                  </div>
                  </div>
                </div>
            </div>
            <div class="item3">
              <div class="list" style="flex-wrap: wrap;" v-if="!isPI">
                <div class="one count" style="margin:5px 10px;" v-for="(item,index) in periodHandleCounts" :key="index" @click="patientListGo(projectItem.id,projectItem.name,item.periodId)">
                  <div class="border"></div>
                  <div class="text">
                    <span>{{item.periodName}}</span>
                    <strong>{{ item.patientCount }}</strong>
                  </div>
                  <query-more class="query-more" color="rgba(48, 198, 203, 1)"
                    bgColor="rgba(234, 249, 250, 1)"></query-more>
                </div>
              </div>
              <div class="list" v-if="!isPI" style="margin-top: 10px;">                
                <!-- <div class="one count" @click="infoClick({name:'当前可随访表单数',value:getNum(projectItem.infoList, '当前可随访表单数')},projectItem.id,projectItem.name)">
                  <div class="border"></div>
                  <div class="text">
                    <span>当前可随访表单数</span>
                    <strong>{{ getNum(projectItem.infoList, '当前可随访表单数') }}</strong>
                  </div>
                  <query-more class="query-more" color="rgba(48, 198, 203, 1)"
                    bgColor="rgba(234, 249, 250, 1)"></query-more>
                </div>
                <div class="two count" @click="infoClick({name:'当前可执行随访人数',value:getNum(projectItem.infoList, '当前可执行随访人数')},projectItem.id,projectItem.name)">
                  <div class="border"></div>
                  <div class="text">
                    <span>当前可执行随访人数</span>
                    <strong>{{ getNum(projectItem.infoList, '当前可执行随访人数') }}</strong>
                  </div>
                  <query-more class="query-more" color="rgba(222, 93, 254, 1)"
                    bgColor="rgba(245, 206, 255, 1)"></query-more>
                </div> -->
                <div class="three count" style="margin:5px 10px;" @click="infoClick({name:'3天内表单过期数',value:getNum(projectItem.infoList, '3天内表单过期数')},projectItem.id,projectItem.name)">
                  <div class="border"></div>
                  <div class="text">
                    <span>3天内表单过期数</span>
                    <strong>{{ getNum(projectItem.infoList, '3天内表单过期数') }}</strong>
                  </div>
                  <query-more class="query-more" color="rgba(55, 110, 255, 1)"
                    bgColor="rgba(195, 212, 255, 1)"></query-more>
                </div>
                <div class="four count" style="margin:5px 10px;" @click="infoClick({name:'待回复质疑数',value:getNum(projectItem.infoList, '待回复质疑数')},projectItem.id,projectItem.name)">
                  <div class="border"></div>
                  <div class="text">
                    <span>待回复质疑数</span>
                    <strong>{{ getNum(projectItem.infoList, '待回复质疑数') }}</strong>
                  </div>
                  <query-more class="query-more"></query-more>
                </div>
              </div>
              <div class="btn-list">
                <a-button class="btn btn1" @click="patientListGo(projectItem.id,projectItem.name)">受试者列表</a-button>
                <!-- <a-button class="btn btn2" @click="periodItemGo(projectItem.id,undefined,projectItem.name)">查看随访</a-button> -->
              </div>
            </div>
            <div class="item4" v-if="menus.length === 2&&(projectItem.status==='1'||projectItem.status==='2')">
              <a-button @click="handleSelect">方案修改</a-button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <project-create-model ref="projectCreateModel" @submit="submitHandle" @deleteChange="loadData"></project-create-model>
    <user-password ref="userPassword"></user-password>
    <center-select ref="centerSelect" title="中心切换"></center-select>
  </div>
</template>

<script>
  import { mapState,mapGetters,mapActions } from 'vuex'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,statusData,CACHE_IS_PAD } from '@/constants/project'
  import { roleData } from '@/constants/projectRole'
  import Vue from 'vue'
  import ProjectStatus from '@/views/management/project/projectList/ProjectStatus'
  import * as echarts from 'echarts'
  import QueryMore from '@comp/Icon/QueryMore'
  import IconBack from '@comp/Icon/IconBack'
  import Sun from '@comp/Icon/Sun'
  import Moon from '@comp/Icon/Moon'
  import ProjectCreateModel from '@views/apppad/index/comp/ProjectCreateModel.vue'
  import UserPassword from '@comp/tools/UserPassword'
  import CenterSelect from '@comp/tools/CenterSelect';
  export default {
    name: 'DataIndex',
    inject:['changeProjectName'],
    components: { ProjectStatus, QueryMore ,IconBack,Sun,Moon,ProjectCreateModel,UserPassword,CenterSelect},
    data(){
      return {
        switchValue: false,
        checkedChildren:<sun></sun>,
        unCheckedChildren:<moon></moon>,
        cacheKEY:'CACHE_PATIENT_LOAD_INFO',
        adminRole:window._CONFIG.adminRole,
        statusData:statusData,
        projectStatus:undefined,
        projectList:[],
        roleData:roleData,

        cur: 0,
        myChart: null,
        projectItem: {},
        curProgress:[],
        menus: [],
        viewInfoData1:{},
        periodRateChart: null,
        monthEnrollChart: null,
        passGroupCenterChart: null,
        currentType: 'week',
        buttonTypes: [
          { label: '周', value: 'week' },
          { label: '月', value: 'month' },          
          { label: '季度', value: 'quarter' },
          { label: '年', value: 'year' }
        ],
        projectId: '',
        periodHandleCounts:[],
      }
    },
    computed: {
      ...mapState({
        // 后台菜单
        permissionMenuList: state => state.user.permissionList
      }),
      isPI(){
        // console.log("this.roles():"+this.roles())
        var ispi = this.roles().filter(role => 'PROJECT_PI' === role.roleCode && this.projectId===role.projectId).length > 0
        console.log("ispi:"+ispi)
        return ispi;
      },
    },
    created() {
      console.log("isPI:"+this.isPI)
      this.menus = this.permissionMenuList.filter(item=>item.location === 1)
    },
    mounted(){
      sessionStorage.removeItem(this.cacheKEY)
      this.loadData();
    },
    methods:{
      ...mapGetters(["roles", "userInfo"]),
      ...mapActions(["Logout"]),
      submitHandle(id) {
        if (id) {
          let that = this
          // this.$confirm({
          //   title: '保存成功！',
          //   content: (<div>
          //     <p>保存成功！是否进行下一步配置？</p>
          //   </div>),
          //   centered: false,
          //   onOk: () => {
          //     this.$router.push({
          //       path: '/pad/projectTemplate',
          //       query: {
          //         id,
          //         goIndex:0
          //       }
          //     })
          //   },
          //   onCancel() {
          //     that.loadData()
          //   },
          // })
          this.$router.push({
                path: '/pad/projectTemplate',
                query: {
                  id,
                  goIndex:0
                }
              })
        }
      },
      handleTypeChange(type) {
        this.currentType = type
        this.monthEnrollChart.dispose();
        var row = 31
        if(type=="month"){
          row = 3
        }else if(type=="week"){
          row = 31
        }else if(type=="quarter"){
          row = 32
        }else if(type=="year"){
          row = 33
        }
        getAction('/management/project/getViewInfo',{projectId:this.projectId,row:row}).then(res=>{
          if(res.success){
            this.initMonthEnrollCharts(res.result["pass_group_center_month"])
          }
        })
      },
      loadView(projectId){
        if(!this.isPI) return
        getAction('/management/project/getViewInfo',{projectId:projectId,row:1}).then(res=>{
          if(res.success){
            this.viewInfoData1 = res.result            
          }
        })        
        getAction('/management/project/getViewInfo',{projectId:projectId,row:2}).then(res=>{
          if(res.success){
            this.initPassGroupCenterChart(res.result["pass_group_center"])
          }
        })
        getAction('/management/project/getViewInfo',{projectId:projectId,row:31}).then(res=>{
          if(res.success){
            this.initMonthEnrollCharts(res.result["pass_group_center_month"])
          }
        })        
        getAction('/management/project/getViewInfo',{projectId:projectId,row:4}).then(res=>{
          if(res.success){            
            this.initPeriodRateChart(res.result["center_form_rate"])
          }
        })
      },
      initPassGroupCenterChart(data) { 
        if(this.passGroupCenterChart)
          this.passGroupCenterChart.dispose();
        // 初始化图表实例
        this.passGroupCenterChart = echarts.init(this.$refs.passGroupCenterChart);
        // console.log(data)

        this.passGroupCenterChart.setOption({
                 title: {            
            text: '{circle|}\t各中心入组统计', // \t 用于添加间隔
            left: 'left',
            // top: '5%',
                  textStyle: {                    
                    rich: {
                    circle: {
                        backgroundColor: '#1890ff', // 圆点颜色
                        width: 6,                   // 圆点宽度
                        height: 6,                  // 圆点高度
                        borderRadius: 3,            // 圆角半径（设为50%为圆形）
                        verticalAlign: 'middle'      // 垂直对齐方式
                        }
                      },
                    fontWeight: 'normal', // 取消加粗
                    fontSize: 16,
                    color: '#333',
                    padding: [0, 0, 0, 10] // 左留白控制圆点位置
                  }
          },
          // grid: {
          //   top: 80, // 图表区域距离容器顶部 80px
          // },
          tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
          legend: {          
            data: data.map(item => ({
              name: item.centerName,
              tooltip: {
                formatter: item.centerName
              }
            })),
            bottom: 10,
            left: 'center',
            formatter: function (name) {
              // 截取前几个字符
              if(data.length > 3 && data.length < 9){
                return name.length > 4 ? name.slice(0, 4) + '..' : name;
              }else if(data.length >= 9){
                return '';
              }
              return name;
            },
            tooltip: {
              show: true
            }
          },
          grid: { top: 60, left: '2%', right: '2%', bottom: 60, containLabel: true },
          xAxis: { type: 'category', data: [''] },
          yAxis: { type: 'value', name: '入组人数(人)' },
          series: data.map(item => ({
            name: item.centerName,
            type: 'bar',
            data: [item.count],
          //   barWidth: 30,
          barMaxWidth: 30,  // 最大宽度

            barMinHeight: 10,  // 最小高度
            itemStyle: { color: item.color },
            label: { show: true, position: 'top', formatter: '{c}' },
            barWidth: '160%',
              barGap: '30%', // 柱子之间的间隙
              // barCategoryGap: '40%' // 类别之间的柱子的总间隙
          }))
        });   
        window.addEventListener('resize', () => {
          this.passGroupCenterChart.resize();
        });            
      },
      initMonthEnrollCharts(data){      
      if(!data) return
      var centers = Object.keys(data)
      var months = data[centers[0]].map(d => d.month)
      var seriesData = centers.map(center => {
        return {
          name: center,
          type: 'line',
          //stack: '人数',
          // data: data[center].map(d => d.count===0?null:d.count),
          data: data[center].map(d => d.count),
          symbol: 'none',
        }
      })
      if(this.monthEnrollChart)
          this.monthEnrollChart.dispose();
      this.monthEnrollChart = echarts.init(this.$refs.monthEnrollChart);
      this.monthEnrollChart.setOption({
        title: {                        
            text: '{circle|}\t入组趋势统计', // \t 用于添加间隔
            left: 'left',
            // top: '5%',
                  textStyle: {                       
                    rich: {
                    circle: {
                        backgroundColor: '#1890ff', // 圆点颜色
                        width: 6,                   // 圆点宽度
                        height: 6,                  // 圆点高度
                        borderRadius: 3,            // 圆角半径（设为50%为圆形）
                        verticalAlign: 'middle'      // 垂直对齐方式
                        }
                      },
                    fontWeight: 'normal', // 取消加粗
                    fontSize: 16,
                    color: '#333',
                    padding: [0, 0, 0, 10] // 左留白控制圆点位置
                  }
  },
  tooltip: {
    trigger: 'axis'
  },  
  legend: {          
          data: centers.map(item => ({
            name: item,
            tooltip: {
              formatter: item
            }
          })),
          bottom: 10,
          left: 'center',
          formatter: function (name) {
            // 截取前几个字符
            if(centers.length > 3 && centers.length < 9){
              return name.length > 4 ? name.slice(0, 4) + '..' : name;
            }else if(centers.length >= 9){
              return '';
            }
            return name;
          },
          tooltip: {
            show: true
          }
        },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '60',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: months
  },
  yAxis: { type: 'value', name: '入组人数(人)' },
  series: seriesData
      });
       // 窗口变化时自适应
       window.addEventListener('resize', () => {
          this.monthEnrollChart.resize();
        });
      },
      initPeriodRateChart(data){
        if(data==null || data.length==0) return
        data=data.filter(item=>item.resRate!='0')        
        var centers = data.map(d => d.centerName)
        const avgPeople = data.map(d => d.resRate)
        const seatRate = data.map(d => d.floRate)

        if(this.periodRateChart)
          this.periodRateChart.dispose();
        // 初始化图表实例
        this.periodRateChart = echarts.init(this.$refs.periodRateChart);
        this.periodRateChart.setOption({
          title: {            
            text: '{circle|}\t应答率/随访率统计', // \t 用于添加间隔
            left: 'left',
            textStyle: {
              rich: {
                circle: {
                  backgroundColor: '#1890ff', // 圆点颜色
                  width: 6,                   // 圆点宽度
                  height: 6,                  // 圆点高度
                  borderRadius: 3,            // 圆角半径（应答率/随访率统计设为50%为圆形）
                  verticalAlign: 'middle'      // 垂直对齐方式
                }
              },
              fontWeight: 'normal', // 取消加粗
              fontSize: 16,
              color: '#333',
              padding: [0, 0, 0, 10] // 左留白控制圆点位置
            }
          }, 
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const index = params[0].dataIndex;
            return `
              ${centers[index]}<br/>
              应答率: ${avgPeople[index]}%<br/>
              随访率: ${seatRate[index]}%
            `;
          }
        },
        legend: {
          data: ['应答率', '随访率'],
          bottom: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: { left: '10%', right: '10%', bottom: 50, containLabel: true },
        xAxis: {
          type: 'value',
          min: -20,
          max: 20,
          splitLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: centers,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: value => `${value}`,
            color: '#333',
            fontSize: 14,
            margin: 40
          }
        },
        //yAxis: { type: 'value', name: '百分比' },
        series: [
          {
            name: '应答率',
            type: 'bar',
            stack: 'total',
            data: avgPeople.map(item => -item),
            barWidth: 14,
            itemStyle: { color: '#14C9C9' },
            label: {
              show: true,
              position: 'left',
              formatter: params => Math.abs(params.value)+'%',
              color: '#333'
            }
          },
          {
            name: '随访率',
            type: 'bar',
            stack: 'total',
            data: seatRate,
            barWidth: 14,
            itemStyle: { color: '#165DFF' },
            label: {
              show: true,
              position: 'right',
              formatter: '{c}%',
              color: '#333'
            }
          }
        ]
      });  
        // 窗口变化时自适应
        window.addEventListener('resize', () => {
          this.periodRateChart.resize();
        });
      }, 
      handleSelect() {
        this.$refs.projectCreateModel.edit(this.projectItem)
      },
      back(){
        this.$router.back()
      },
      async loadData() {
        // const res1 = await getAction('/management/project/listByUser', { status: this.projectStatus })
        const res1 = await getAction('/management/project/getProjectList', { status: this.projectStatus })
        if (res1.success) {
          const id = res1.result[0].id;
          this.projectId = id
          this.projectList = res1.result;
          this.projectItem = this.projectList[this.cur]
          this.getPeriodHandleCount(id);
          this.loadView(id)
          this.getProjectDetail(id);
          this.getProgressById(id);          
        }
      },
      async getProjectDetail(id){
        const res = await getAction('/management/project/getProjectDetail', { id })
          if (res.success && res.result) {
            // this.projectItem = res.result
            this.$set(this.projectItem,"memberList",res.result.memberList)
            this.$set(this.projectItem,"infoList",res.result.infoList)
          }
      },
      async getProgressById(id){
        return
        const res = await getAction('/management/project/getProgressById', { id })
          if (res.success) {
            this.curProgress = res.result;
            res.result.forEach((item,index)=>{
              this.initChart(`chart${index}`, item.title, item.value);
            })
          }
      },
      getPeriodHandleCount(projectId){
        getAction('/management/project/getPeriodHandle',{id:projectId}).then(res=>{
          if(res.success){
            this.periodHandleCounts = res.result
          }
        })
      },

      statusChange(){
        this.loadData()
      },
      infoClick(item,projectId,projectName){
        this.updateProjectCache(projectId,projectName)
        if(item.name==='当前可随访表单数'){
          this.periodItemGo(projectId,undefined,projectName)
        }
        else if(item.name==='当前可执行随访人数'){
          this.$router.push({
            path:'/pad/patient',
            query:{
              projectId:projectId,
              input:'1',
            }
          })
        }
        else if(item.name==='3天内表单过期数'){
          this.periodItemGo(projectId,'1',projectName)
        }
        else if(item.name==='待回复质疑数'){
          this.$router.push({
            path:'/pad/question',
            query:{
              projectId:projectId,
              handleStatus:1,//未处理
              status:1, // 未关闭
              isDataUser:1 //数据录入用户
            }
          })
        }
      },
      patientListGo(projectId,projectName, periodId){
        console.log("-------projectId-------")
        this.updateProjectCache(projectId,projectName)
        this.$router.push({
          path:'/pad/patient',
          query:{
            projectId:projectId,
            periodId:periodId,
          }
        })
      },
      periodItemGo(projectId,delay,projectName){
        this.updateProjectCache(projectId,projectName)
        //  跳转到执行随访列表
        this.$router.push({
          path:'/pad/periodForm',
          query:{
            projectId:projectId,
            delay:delay
          }
        })
      },
      updateProjectCache(projectId,projectName){
        Vue.ls.set(CACHE_PROJECT_ID,projectId)
        Vue.ls.set(CACHE_IS_PAD,true)
        Vue.ls.set(CACHE_PROJECT_NAME,projectName)
        this.changeProjectName(projectName)
      },
      handleInfo(info){
        const infoList = []
        for (var name in info){
          if(info[name].role ==='PROJECT_GATHER'|| info[name].role ==='PROJECT_MANAGER' || info[name].role ==='PROJECT_CENTER'){
            infoList.push({
              name:name,
              value:info[name]
            })
          }          
        }        
        return infoList
      },
      handleClick(index) {
        this.cur = index
        this.projectItem = this.projectList[index]
        // this.handleInfo(this.projectList[index].infoList)
        this.projectId = this.projectList[index].id
        this.getPeriodHandleCount(this.projectList[index].id);
        this.loadView(this.projectList[index].id)
        this.getProjectDetail(this.projectList[index].id)
        this.getProgressById(this.projectList[index].id)        
        this.currentType = 'week'
      },
     /* handleInfo(info) {
        const infoList = []
        for (let name in info) {
          if (name !== '待回复质疑数' && name !== 'role') {
            infoList.push({
              name: name,
              value: info[name]
            })
          }
        }
        for (let name in info) {
          if (name === '待回复质疑数') {
            infoList.push({
              name: name,
              value: info[name]
            })
          }
        }

        return infoList
      },*/
      getNum(info, key) {
        const len = this.handleInfo(info).length
        if (len === 0) return 0
        return this.handleInfo(info)[0].value[key] || 0
      },
      initChart(id, text, percent) {
        this.$nextTick(()=>{
          const ele = document.getElementById(id);
          if(ele){
            const chart = echarts.init(ele)
            const data = [
              { value: percent, name: text, itemStyle: { color: 'rgba(55, 110, 255, 1)' } },
              { value: 100 - percent, name: 'XXX', itemStyle: { color: '#efefef' } }
            ]
            const total = data.reduce((sum, item) => sum + item.value, 0)
            const initialPercentage = ((data[0].value / total) * 100).toFixed(0)

            const option = {
              tooltip: {
                // trigger: 'item'
                show:false
              },
              series: [
                {
                  // name: 'Access From',
                  type: 'pie',
                  radius: ['53%', '70%'],
                  avoidLabelOverlap: false,
                  label: {
                    show: false,
                    position: 'center'
                  },
                  labelLine: {
                    show: false
                  },
                  data
                }
              ],
              graphic: {
                elements: [
                  {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    style: {
                      text: initialPercentage + '%',
                      textAlign: 'center',
                      fill: '#000',
                      fontSize: 12
                    }
                  }
                ]
              }
            }
            chart.setOption(option)
          }
        })
      },
      handleCreate(){
        postAction('/projectconfigview/configProject/limitCount').then(res=>{
          if(res.success){
            this.$refs.projectCreateModel.add()
          }else{
            this.$message.error(res.message)
          }
        })
      },
      handleLogout() {
        const that = this
        this.$confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk() {
            return that.Logout({}).then(() => {
              // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
              // that.$router.push({ path: '/pad' });
              that.$router.push({ path: '/user/login',query:{
                  redirect:'/pad'
                } });
              // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
              //window.location.reload()
            }).catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
          },
          onCancel() {
          },
        });
      },
      updatePassword(){
        let username = this.userInfo().username
        this.$refs.userPassword.show(username)
      },
      updateCurrentCenterId(){        
        this.$refs.centerSelect.show()
      },
      // async invokeNativeClearCache(){
      //   try {
      //     // 调用 Android 原生方法
      //     if (window.AndroidBridge) {
      //       this.$message.info("开始更新系统...")
      //       window.AndroidBridge.clearWebViewCache('handleClearCacheResult');
      //       this.$message.info("已完成系统更新")
      //     }else{
      //         this.$message.warning("当前版本没有该功能，请重新安装最新版本")
      //     }
      //   }catch (error) {
      //     this.$message.error("系统更新失败,"+error.message)
      //   }    
      // },
      reloadWindow(){
        window.location.reload(true)
        this.$message.info("已完成系统更新")
      },
    }
  }
</script>

<style scoped lang="less">

  .project-card{
    margin: 5px 10px;
    background-color: white;
    /*padding: 10px;*/
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 7px;
    box-shadow: 0px 3px 3px 0px rgba(0,0,0,0.2);
    .project-name{
      background-color: #F0F2F0;
      padding: 10px;
      border-radius: 7px;
      .name{
        font-size: 16px;
        font-weight: bold;
      }
    }
    .info-panel{
      padding: 10px;
      .contact{
        margin-bottom: 5px;
        font-weight: bold;
      }
      .info{
        text-align: center;
        .value{
          margin: 5px;
          font-size: 22px;
          color: rgba(0,0,0,1);
        }
        .name{
          color: white;
        }
        border-radius: 5px;
        margin-right: 1px;
      }
      .info1{
        border: 2px solid rgba(129,166,125,0.8);
        .value{
          /*color: rgba(129,166,125,0.8);*/
        }
        .name{
          background-color: rgba(129,166,125,0.8);
        }
      }
      .info2{
        border: 2px solid rgba(56,35,252,0.5);
        .value{
          /*color: rgba(56,35,252,0.5);*/
        }
        .name{
          background-color: rgba(56,35,252,0.5);
        }
      }
      .info3{
        border: 2px solid rgba(63,119,182,0.6);
        .value{
          /*color: rgba(63,119,182,0.6);*/
        }
        .name{
          background-color: rgba(63,119,182,0.6);
        }
      }
      .info4{
        border: 2px solid rgba(217,70,88,0.7);
        .value{
          /*color: rgba(217,70,88,0.7);*/
        }
        .name{
          background-color: rgba(217,70,88,0.7);
        }
      }
      .btn-panel{
        text-align: right;
        .btn{
          width: 85px;
          margin-top: 5px;
          margin-left: 5px;
        }
      }
    }
  }

  @color1: #0582f7;

.box {
  background:#f5f6fa url(~@/assets/bg03.png) center top no-repeat;
  background-size: contain;

  header{
    height: 100px;
    padding: 0 20px;
    border-bottom: 1px solid #DFE1E5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left{
      display: flex;
      gap: 20px;
      align-items: center;
      img{
        border-radius: 50%;
      }
    }
    .name{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #48494D;
      strong{
        font-size: 16px;
      }
      span{
        display: inline-block;
        width: 34px;
        height: 20px;
        border-radius: 42px;
        background: rgba(55, 110, 255, 1);
        font-size: 11px;
        text-align: center;
        line-height: 20px;
      }
    }
    .position{
      font-size: 13px;
      color: rgba(110, 117, 132, 1);
      margin-top: 5px;
    }
    .right{
      button{
        width: 120px;
        height: 48px;
        font-size: 16px;
        color: white;
        background-color: rgba(55, 110, 255, 1);
        border-color: rgba(55, 110, 255, 1);
        border-radius: 38px;
      }
    }
  }
  main{
    display: flex;
    align-items: stretch;
    .left::-webkit-scrollbar,
    .right::-webkit-scrollbar {
        display: none;
      }
    .left {
      position: relative;
      min-width: 280px;
      height: calc(100vh - 100px);
      overflow: auto;
      .top{
        height: 41px;
        position: relative;
        border-bottom: 1px solid rgba(223, 225, 229, 1);

        .back {
          position: absolute;
          left: 20px;
          top: 10px;
        }

        button{
          position: absolute;
          left: 30px;
          top: 8px;
        }
        strong{
          display: block;
          height: 100%;
          line-height: 41px;
          font-size: 16px;
          color: rgba(33, 34, 39, 1);
          text-align: center;
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
        overflow: auto;

        .main.main1 {
          background: #1890ff url(~@/assets/logo-bg-blue.png) right top no-repeat !important;
          color: white !important;
          
          .title span {
            color: white !important;
          }
          
          .item dt {
            color: rgba(255, 255, 255, 0.7) !important;
          }
          
          .item1 dd,
          .item2 dd {
            color: white !important;
          }
          
          .item1 .dd-list {
            background: rgba(255, 255, 255, 0.15) !important;
          }
        }

        .main2 {
          background: white url(~@/assets/logo-bg-white.png) right top no-repeat;

          .title {
            span {
              color: rgba(72, 73, 77, 1);
            }
          }

          .item {
            dt {
              color: #77797E;
            }
          }

          .item1 dd,
          .item2 dd {
            color: #48494D;
          }

          .item1 {
            .dd-list {
              background: #EEEFF6;
            }
          }
        }

        .main {
          border-radius: 12px;
          padding: 10px;
          cursor: pointer;
          width: 260px;

          .title {
            display: flex;
            align-items: center;

            span {
              font-size: 18px;
              font-weight: 600;
              margin: -3px 0 0 15px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 160px;
            }
          }

          .item {
            display: flex;
            margin-top: 15px;

            dl {
              margin-bottom: 0;
            }

            dt {
              font-size: 12px;
              font-weight: 400;
              line-height: 20px;
              white-space: nowrap;
            }
          }

          .item2 dd {
            display: inline-block;
            margin: 0 8px 0 0;
            border-radius: 8px;
          }

          .item1 {
            dl {
              margin-right: 30px;
            }

            dd {
              margin: 0;
              display: flex;
              flex-wrap: nowrap;
              gap: 10px;
              align-items: flex-start;
            }
            .dd-list{
              font-weight: 600;
              font-size: 12px;
              line-height: 26px;
              padding: 0 8px;
              // margin: 0 8px 0 0;
              border-radius: 8px;
              white-space: nowrap;
            }
          }

          .item2 {
            justify-content: space-between;

            dd {
              font-weight: 600;
              font-size: 12px;
            }
          }
        }
      }
      .empty{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .line {
      min-width: 1px;
      height: calc(100vh - 100px);
      background-color: #DFE1E5;
    }

    .right {
      width: calc(100vw - 281px);
      height: calc(100vh - 100px);
      overflow: auto;
      .top{
        text-align: center;
        height: 41px;
        line-height: 41px;
        border-bottom: 1px solid rgba(223, 225, 229, 1);
        font-size: 16px;
        font-weight: 600;
        color: rgba(33, 34, 39, 1);
        text-align: center;
      }

      .scroll-content{
        padding: 12px;
      }
      .right-content {
        // margin: 12px;
        padding: 20px;
        border-radius: 12px;
        background: white url(~@/assets/logo-bg-white.png) right top no-repeat;

        .item1 {
          .title {
            display: flex;
            align-items: center;

            strong {
              font-weight: 600;
              font-size: 18px;
              color: #48494D;
              line-height: 21px;
              margin: 0 12px;
            }

            // /deep/ .ant-tag {
            //   color: white;
            //   background-color: #30C6CB;
            //   border-radius: 28px;
            // }
          }

          .user {
            display: flex;
            align-items: flex-start;
            gap: 20px;
            padding: 20px 0;

            /deep/ .ant-tag {
              color: white;
              background-color: @color1;
            }

            .num {
              display: flex;
              flex-direction: column;
              min-width: 75px;
              span {
                font-weight: 400;
                font-size: 12px;
                color: #77797E;
              }

              strong {
                font-weight: bold;
                font-size: 16px;
                color: #48494D;
                text-align: center;
              }
            }

            .pm {
              display: flex;
              align-items: center;

              img {
                border-radius: 50%;
                border: 1px solid @color1;
              }

              .job {
                display: flex;
                flex-direction: column;
                margin-left: 10px;

                strong {
                  font-weight: 600;
                  font-size: 11px;
                  color: #48494D;
                }
              }
            }

            .user-list {
              display: flex;
              flex-wrap: wrap;
              gap: 20px;
            }
          }
        }

        .item2 {
          border-top: 1px solid #DFE1E5;
          border-bottom: 1px solid #DFE1E5;
          padding: 20px 0;

          .title {
            font-weight: 400;
            font-size: 12px;
            color: #77797E;
          }

          .chart-list {
            display: flex;
            justify-content: space-between;
          }

          .chart {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-left: -22px;
          }

          .discribe {
            display: flex;
            flex-direction: column;

            strong {
              font-weight: 600;
              font-size: 14px;
              color: #48494D;
            }

            span {
              font-weight: 400;
              font-size: 12px;
              color: #77797E;
            }
          }
        }

        .item3 {
          overflow: hidden;
          padding: 20px 0 0;
          .list {
            display: flex;
            //justify-content: space-between;
            justify-content: flex-start;
            align-items: center;
          }

          .count {
            display: flex;
            align-items: center;
            width: 195px;
            border-radius: 8px 8px 8px 8px;

            .border {
              width: 5px;
              height: 72px;

              border-radius: 8px 0px 0px 8px;
            }

            .text {
              display: flex;
              flex-direction: column;
              margin-left: 10px;

              span {
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
              }

              strong {
                font-weight: bold;
                font-size: 28px;
                line-height: 33px;
              }
            }

            .query-more {
              margin-left: auto;
              margin-right: 10px;
            }
          }

          .one {
            background: linear-gradient(90deg, #FFFFFF 0%, #F4FDFE 100%);

            .border {
              background: #30C6CB;
            }

            .text {
              color: #30C6CB;
            }
          }

          .two {
            background: linear-gradient(90deg, #FFFFFF 0%, #FAF4FE 100%);

            .border {
              background: #DE5DFE;
            }

            .text {
              color: #DE5DFE;
            }
          }

          .three {
            background: linear-gradient(90deg, #FFFFFF 0%, #F4F6FE 100%);

            .border {
              background: #376EFF;
            }

            .text {
              color: #376EFF;
            }
          }

          .four {
            background: linear-gradient(90deg, #FFFFFF 0%, #FEF4F4 100%);

            .border {
              background: #FE543E;
            }

            .text {
              color: #FE543E;
            }
          }

          .btn-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 20px;
            margin-top: 20px;

            .btn {
              width: 405px;
              height: 65px;
              font-size: 18px;
              font-weight: 600;
              border-radius: 8px 8px 8px 8px;
            }

            .btn1 {
              color: white;
              background: @color1;
              border-color: @color1;
            }

            .btn2 {
              color: @color1;
              background: #EAF0FF;
              border-color: #EAF0FF;
            }
          }
        }

        .item4{
          overflow: hidden;
          padding: 20px 0 0;
          margin-top: 20px;
          border-top: 1px solid #DFE1E5;
          button{
            width: 100%;
            height: 65px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 8px 8px 8px 8px;
            color: white;
            background: @color1;
            border-color: @color1;
          }
        }
      }
    }
  }
}

// .left,
// .line,
// .right {
//   height: calc(100vh - 59px);
//   overflow: auto;
// }

// .left::-webkit-scrollbar,
// .line::-webkit-scrollbar,
// .right::-webkit-scrollbar {
//   display: none;
// }




</style>

<style scoped>
.switch-center {
  color: #1890ff;
  cursor: pointer;
  margin-left: 8px;
}
.switch-center:hover {
  text-decoration: underline;
}
.report-container {
  padding: 0 10px;
}
.module {
  margin-bottom: 0px;
  border: 1px solid #fffff7;
  border-radius: 4px;
  padding: 2px;
}
.section-title {
  /* background-color: #f5f5f5; */
  padding: 12px 20px;
  margin: 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  height: 5px;
  border-bottom: 1px solid #f5f5f5; /* 添加下划线 */
}
.module-content {
  display: flex;
  margin-top: 5px;
}
.column {
  padding: 0;
  position: relative;
}
.column:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 1%;
  height: 94%;
  width: 1px;
  background-color: #e8e8e8;
  /* margin-right: 20px;
  margin-left: 20px; */
}
.column:first-child {
  flex: 0 0 100%;
  max-width: 100%;
}
.column:not(:first-child) {
  flex: 0 0 30%;
  max-width: 30%;
}
.row {
  margin-bottom: 10px;
  display: flex;
  gap: 10px; /* 卡片间距 */
}
.data-item, .text {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  flex: 1;
  background: #F6F8FA;
}
.data-card {
  flex: 1;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  text-align: center;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.data-label {
  margin-bottom: 15px; /* 增加标签和数值间距 */
}
.data-value {
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 26px;
  color: rgba(0,0,0,0.88);
  line-height: 42px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: -8px
}
.data-label {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.65);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: flex;
  align-items: center;
}
.data-icon {
  margin-right: 6px;
}

.stats-row {
  display: flex;
  margin-bottom: 15px !important;
}
.chart-1 {
  width: 100%;
  height: 280px; /* 增加高度 */
  /* margin-bottom: 3px; */
  position: relative;
}
.chart-2 {
  width: 100%;
  height: 280px; /* 增加高度 */
  margin-bottom: 10px; /* 减少底部间距 */
}
.chart-3 {
  width: 100%;
  height: 320px; /* 增加高度 */
  margin-bottom: 10px; /* 减少底部间距 */
}


        .timeButtons button {
          margin-right: 3px;
          border-color: #c0baba;
          border-radius: 12px;
          border-style: solid;
          border-width: 1px;
          padding: 3px 8px;
          border: 1px solid #d9d9d9;                
          background: #fff;
          color: rgba(0, 0, 0, 0.65);
          cursor: pointer;
          transition: all 0.3s;
          font-size: 14px;
        }

        /* 按钮组样式 */
        .timeButtons {
            position: absolute;
            top: 3px;
            right: 2px;
            z-index: 1000;
            /* background: rgba(255, 255, 255, 0.9); */
            border-radius: 4px;
            /* padding: 5px; */
            /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
        }        

        /* 悬停状态 */
        .timeButtons button:hover {
            background: #b9babb;
            border-color: #c0c4cc;
        }

        /* 选中状态 */
        .timeButtons button.active {
            background: #409eff;
            color: white;
            border-color: #409eff;
        }


</style>